export const downloadFileFromUrl = async (url: string, fileName: string) => {
    const link = document.createElement('a');
    link.href = url;
    link.target = 'blank';
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
